<template>
<div class="grid mt-4">	

<div class="col-12 ">

<span class="p-float-label">
<Dropdown :filter="true"  v-model="$store.state.calculations.selectednode.data.selected_project_id" :options="projects" optionLabel="name" optionValue="id" class="w-full p-inputtext-sm" :id="$store.state.calculations.selectednode.id" @change="projectSelected"/>
<label :for="$store.state.calculations.selectednode.id" class="text-primary">Seçili Proje</label>
</span>
</div>


<div class="col-12 mt-4" v-if="projectperiods.length">
<span class="p-float-label">
<Dropdown :filter="true"  v-model="$store.state.calculations.selectednode.data.period_id" :options="projectperiods" optionLabel="name" optionValue="id" class="w-full p-inputtext-sm" id="period" />
<label for="period" class="text-primary">Dönem</label>
</span>
</div>

<div v-if="period"></div>


<div class="col-12 mt-2" v-if="$store.state.calculations.selectednode.data.selected_project_id">


<SelectButton v-model="$store.state.calculations.selectednode.data.selected_value" :options="include_options" aria-labelledby="custom" optionLabel="name" optionValue="value" />


<div class="col-12 mt-4" v-if="$store.state.calculations.selectednode.data.selected_project_id">
<label  class="text-primary ">Durumu</label>
</div>
<div class="col-12 mt-2" v-if="$store.state.calculations.selectednode.data.selected_project_id">

<div class="field-checkbox" v-for="option in statuses">
<Checkbox :id="$store.state.calculations.selectednode.id+option.id"  :value="option.id" v-model="$store.state.calculations.selectednode.selected_statuses" />
<label :for="$store.state.calculations.selectednode.id+option.id">{{option.name}}</label>
</div>

</div>

</div>


</div>
</template>

<script>
export default {

  name: 'ProjectNodeData',
  props:["projects"],

  data () {
    return {
    	statuses:[
    		{name:"Oluşturuldu",id:"created"},
    		{name:"Başlandı",id:"started"},
    		{name:"Tamamlandı",id:"finished"},
    		{name:"Silindi",id:"deleted"},
    	],    	
    	include_options:[
        {name:"Projeye Dahil",value:"included"},
        {name:"Projeye Dahil Değil",value:"notincluded"},
      ],
      projectperiods:[],
    }
  },
  computed:{
    period()
    {
      if(this.$store.state.calculations.selectednode.data.period_id)
      {
        this.getProjectPeriods()
        return this.$store.state.calculations.selectednode.data.period_id
      }
    }
  },
  methods:{
    projectSelected()
    {
      this.getProjectPeriods()
    },
    async getProjectPeriods()
    {
      this.projectperiods = await this.generalApiGetWithoutLoader("projectperiods/"+this.$store.state.calculations.selectednode.data.selected_project_id)
    },
  }
}
</script>

<style lang="css" scoped>
</style>